export type WizardSaveStatus = 'idle' | 'saving' | 'saved' | 'failed';

export function wizardSaveStatusMessage(
  status: WizardSaveStatus,
  options: {
    hasUnsavedChanges?: boolean;
    lastSavedAt?: Date | null;
    error?: string | null;
    formatSavedAt?: (d: Date) => string;
  } = {},
): { primary: string; secondary?: string } {
  const format =
    options.formatSavedAt ??
    ((d: Date) => d.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' }));

  switch (status) {
    case 'saving':
      return { primary: 'Saving…', secondary: 'Saving changes' };
    case 'failed':
      return {
        primary: options.error?.trim() || 'Save failed',
        secondary: options.error?.trim()
          ? undefined
          : 'Changes will retry auto-saving or save when you continue. (Retry)',
      };
    case 'saved':
      return {
        primary: options.lastSavedAt ? `Saved at ${format(options.lastSavedAt)}` : 'All changes saved',
        secondary: options.hasUnsavedChanges ? 'Saving new edits…' : 'Saved to draft',
      };
    default:
      if (options.hasUnsavedChanges) {
        return {
          primary: options.lastSavedAt ? `Unsaved changes (Last saved ${format(options.lastSavedAt)})` : 'Unsaved changes',
          secondary: 'Auto-saving in a moment…',
        };
      }
      if (options.lastSavedAt) {
        return { primary: `Saved at ${format(options.lastSavedAt)}`, secondary: 'All changes saved' };
      }
      return { primary: 'Auto-save enabled', secondary: 'Changes save automatically' };
  }
}
